import styled from 'styled-components';

import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import addUser from '@sorare/core/src/assets/user/add-user.svg';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Locker } from '@sorare/core/src/atoms/icons/Locker';
import { iconAlert } from '@sorare/core/src/atoms/icons/system/iconAlert.ts';
import { iconCheck } from '@sorare/core/src/atoms/icons/system/iconCheck.ts';

const IconWrapper = styled.span`
  opacity: 0.4;
  pointer-events: none;
`;

type Props = {
  rarity: Rarity;
  locked: boolean;
  empty: boolean;
  available: boolean;
};

export const PlaceholderIcon = ({
  rarity,
  locked,
  empty,
  available,
}: Props) => {
  if (locked) {
    if (rarity === 'common' || available) {
      return (
        <FontAwesomeIcon
          icon={iconCheck}
          size="lg"
          color="var(--c-onBase-success)"
        />
      );
    }
    return (
      <IconWrapper>
        <Locker title="locked" />
      </IconWrapper>
    );
  }
  if (empty) {
    return (
      <IconWrapper>
        <img src={addUser} alt="Add Player" />
      </IconWrapper>
    );
  }
  return <FontAwesomeIcon icon={iconAlert} size="lg" />;
};
